<nav class="mobile-bottom-nav" [class.is-expanded]="isExpanded">
  <div class="nav-grid">
    @for (item of topRowItems; track item.testId) {
      <button
        class="nav-item"
        [class.active]="tabIndex === dynamicTabIndex(item)"
        [class.is-pressed]="pressedTestId === item.testId"
        (touchstart)="pressedTestId = item.testId"
        (touchend)="pressedTestId = null"
        (touchcancel)="pressedTestId = null"
        (click)="selectTab(item)"
        [attr.data-testid]="item.testId"
      >
        <odx-icon [name]="item.icon" [size]="iconSize"></odx-icon>
        <span class="nav-label odx-text--xsmall">{{ item.label }}</span>
      </button>
    }

    @for (item of bottomRowItems; track item.testId) {
      <div class="secondary-item-wrapper">
        <button
          class="nav-item"
          [class.active]="tabIndex === dynamicTabIndex(item)"
          [class.is-pressed]="pressedTestId === item.testId"
          (touchstart)="pressedTestId = item.testId"
          (touchend)="pressedTestId = null"
          (touchcancel)="pressedTestId = null"
          (click)="selectTab(item)"
          [attr.data-testid]="item.testId"
        >
          <odx-icon [name]="item.icon" [size]="iconSize"></odx-icon>
          <span class="nav-label odx-text--xsmall">{{ item.label }}</span>
        </button>
      </div>
    }

    <button
      class="nav-item show-more-btn"
      [class.expanded]="isExpanded"
      [class.is-pressed]="pressedTestId === 'mobileNav.showMore'"
      (touchstart)="pressedTestId = 'mobileNav.showMore'"
      (touchend)="pressedTestId = null"
      (touchcancel)="pressedTestId = null"
      (click)="toggleExpand()"
      [attr.data-testid]="'mobileNav.showMore'"
    >
      <odx-icon [name]="isExpanded ? 'chevron-down' : 'chevron-up'" [size]="iconSize"></odx-icon>
      <span class="nav-label odx-text--xsmall">{{ isExpanded ? showLessButtonText : showMoreButtonText }}</span>
    </button>
  </div>
</nav>
